module.exports = __webpack_public_path__ + "img/how-rpc-work-3.c558ef10.png";